import { render, staticRenderFns } from "./fccPublicacoesConfig.vue?vue&type=template&id=c284fa8a"
import script from "./fccPublicacoesConfig.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports